/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-unused-vars */
import React, {useCallback, useEffect, useState} from 'react'
import { useLocation, useSearchParams } from 'react-router-dom';
import TableHeader from './listingHeader';
import TableBody from './listingBody';
import { dataService } from '../../services/dataService';
import ToastMeassage from '../../CommonComponent/toastMeasseage';
import Modal from '../../CommonComponent/Modal';
import Paginate from '../Auction/listAuction/paginate';

export default function AllBidders() {
    const [searchParams, setSearchParams] = 
    useSearchParams({ page:  1, sort_key : "created_at", sort_order : "descending"});
    const [bidders,setBidders]= useState([]);
    const [loading, setLoading]=useState(false);
    const [biddersInfo,setBiddersInfo]= useState([]);
    const [message, setMessage]=useState("");
    const [isFilterApplied, setIsFilterApplied]=useState(false);
    const location = useLocation();
    const [profile,setProfile]=useState({})
    const [currentSortColumn, setCurrentSortColumn] = useState({key:null, sort_order: 'ascending'});
    const [ isOpen,setIsOpen] = useState(false);
    const [showExportModel, setShowExportModel] =useState('')
    const [exportBtnLoading, setExportBtnLoading]=useState(false)
    const [loader,setLoader]=useState(false);
    const [bidderExportCsvUrl, setBidderExportCsvUrl]=useState('')

    /* Builds the bidder-list query string from the current search params, optionally appending
    extra params (e.g. the export flag) without ever writing those extras back to the URL. */
    const buildEndpoint = (extra = '') => {
        let ep = `?page_number=${Number(searchParams.get('page'))===0? 1: Number(searchParams.get('page'))}${extra}`
        if(searchParams.get('keyword')!==null){
            ep += `&search=${searchParams.get('keyword')}`
        }
        if(searchParams.get('sort_key')!==null){
            ep += `&sort_by=${String(searchParams.get('sort_key'))}&sort_order=${String(searchParams.get('sort_order'))}`
        }
        if(searchParams.get('status')!==null){
            ep += `&status=${searchParams.get('status').replaceAll("+", ' ')}`
        }
        if(searchParams.get('start_date')!==null){
            ep += `&start_date=${searchParams.get('start_date')}&end_date=${searchParams.get('end_date')}`
        }
        return ep;
    }

    /* The `handleFetch` function is a callback function that is used to fetch auction data based on
the search parameters. It is called whenever there is a change in the search parameters or when
the component mounts. */
    const handleFetch=useCallback(async()=>{
        setLoading(true)
        const response=await dataService.AllBidderList(buildEndpoint())
        if(response.error===false){
            setBidders(response.data.buyers);
            setBiddersInfo(response.data);
        }
        setLoading(false);
    },[location])

    /**
 * The handleSearch function updates the search parameters based on the provided key and value, and
 * then sets the updated search parameters.
 */
    const handleSearch=(e, key, value)=>{
        e.preventDefault();
        let params = Object.fromEntries(searchParams);
        params.page = 1
        if(key === 'keyword') {
            params[key] = encodeURIComponent(value); 
        }else {
            params[key] = value
        }
        if(params['keyword'] === '') delete params.keyword
        setSearchParams({ ...params})
    }

    const handleExport = async () => {
        setLoader(true);
        const response = await dataService.AllBidderList(buildEndpoint('&export=true'));
        if(response.error===false && response.data?.csv_url){
            window.open(response.data.csv_url, '_blank');
            setIsOpen(false);
            setMessage("Export complete");
            setTimeout(() => {
                setMessage("");
            }, 5000);
        }
        setLoader(false);
    }

    /**
 * The function `handleSort` is used to update the search parameters based on the sorting key and
 * order.
 */
    const handleSort=(e,key)=>{
        let params = Object.fromEntries(searchParams);
        if(searchParams.get('sort_key') ==null) {
            params['sort_key'] = `${key}`
            params['sort_order'] = `ascending`
            setCurrentSortColumn({
                key: key,
                sort_order: 'ascending'
            });
        }else {
            if(searchParams.get('sort_key')==key)
            {
                if(searchParams.get('sort_order')==='ascending') {
                    params['sort_order'] = `descending`
                    setCurrentSortColumn({
                        key: key,
                        sort_order: 'descending'
                    });
                }else{
                    params['sort_order'] = `ascending`
                    setCurrentSortColumn({
                        key: key,
                        sort_order: 'ascending'
                    });
                }
            }
            else {
                params['sort_key'] = key
                params['sort_order'] = `ascending`
                setCurrentSortColumn({
                    key: key,
                    sort_order: 'ascending'
                });
            }
        }
        setSearchParams({ ...params})
    }

    /**
 * The function updates the search parameters with a new page number when a page number is clicked.
 */
    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page: pageNum.selected + 1 })
    }

    useEffect(()=>{
        handleFetch()
    }, [handleFetch])

    return (
        <div className="sm:mx-10 mx-5 sm:my-8 mt-8 mb-20 ">
            <Modal isOpen={isOpen} setIsOpen={setIsOpen} handleAction={handleExport} buttonText="Export"
                close={true} notShowCancel={false} loading={loader} id="export-btn"
                title="You are about to export the auction Bidders data."
                description="By clicking ‘Export’, you acknowledge your responsibility for the safe handling of this data and agree to comply with all relevant laws and regulations as well as the Indy.auction terms of use." />
            {message!=="" && <ToastMeassage message={message}  />}
            <TableHeader
                bidders={bidders}
                profile={profile}
                message={message}
                loading={loading}
                biddersInfo={biddersInfo}
                setMessage={setMessage}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
                handleSearch={handleSearch} 
                isFilterApplied={isFilterApplied}
                setIsFilterApplied={setIsFilterApplied}
                handleExport={handleExport}
                setIsOpen={setIsOpen}                
            />
            <div className="pb-5 pt-2 overflow-auto " data-testid="bidders-table">
                <TableBody
                    bidders={bidders}
                    handleSort={handleSort}
                    loading={loading}
                    biddersInfo={biddersInfo}
                    isFilterApplied={isFilterApplied}
                    searchParams={searchParams}
                    currentSortColumn={currentSortColumn}
                  
                />
            </div>
            {(biddersInfo.page_number <= biddersInfo.total_buyers) &&
            <Paginate
                totalPageNumber={Math.ceil(biddersInfo.total_buyers/10)}
                selectedPageNumber={Number(searchParams.get('page')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber} 
            />
            }
        </div>
    )
}
